import './index.scss'
// import '../../assets/scripts/myNiceScroll'
// import {resizeScroll} from '../../assets/scripts/myNiceScroll'
import '@fancyapps/fancybox/dist/jquery.fancybox.min'

$('.case-list li .item-img,.case-list li .item-text').on('click',function(){
  let parents = $(this).closest('li')
  let album = parents.find('.item-album a')

  if( album.length > 0){
    album.eq(0).click()
  }
})

if($('.section3 ul li').length > 6){
  $('.section3 ul').addClass('line-three')
}